import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div class=\"form-info\" ...attributes>\n  <NwIcon @icon=\"icon-info\" />\n  {{yield}}\n</div>")